<template>
  <div>
    <a-card :bordered="false">
      <a-form :form="form">
        <a-row :gutter="12">
          <a-col :span="6">
            <a-form-item>
              <a-select
                v-decorator="['signupId']"
                size="large"
                style="width: 100%"
                placeholder="请选择报名"
              >
                <a-select-option
                  v-for="item of signupList"
                  :value="item.signupNoticeId"
                >{{item.title}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!--管理员才有查看街道的权限-->
          <a-col :span="4" v-if="adminLevel === 'admin'">
            <a-form-item>
              <a-select
                allowClear
                v-decorator="['street']"
                size="large"
                style="width: 100%"
                placeholder="请选择街道"
                @change="beforeChangeStreet"
              >
                <a-select-option
                  v-for="(item, index) of streetList"
                  :key="index"
                  :value="item.code"
                >{{item.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!--<a-col :span="4" v-show="this.villageList.length > 0">-->
            <!--<a-form-item>-->
              <!--<a-select-->
                <!--allowClear-->
                <!--v-decorator="['villageCode']"-->
                <!--size="large"-->
                <!--style="width: 100%"-->
                <!--placeholder="请选择社区"-->
                <!--@change="beforeChangeVillage"-->
              <!--&gt;-->
                <!--<a-select-option v-for="item of villageList" :value="item.code">{{item.name}}</a-select-option>-->
              <!--</a-select>-->
            <!--</a-form-item>-->
          <!--</a-col>-->
          <template v-if="adminLevel === 'admin'">
            <!--幼儿园版本管理员可以查看学校-->
            <a-col :span="5" v-if="studentType === 1">
              <a-form-item>
                <a-select
                  allowClear
                  :dropdownMatchSelectWidth="false"
                  :notFoundContent="'暂无数据！'"
                  v-decorator="['school']"
                  size="large"
                  style="width: 100%"
                  placeholder="请选择幼儿园"
                  @change="onChangeSchool"
                >
                  <a-select-option v-for="item of schoolList" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <!--中小学版本管理员可以查看年级-->
          <a-col :span="4" v-if="studentType === 2">
            <a-form-item>
              <a-select
                v-decorator="['grade']"
                size="large"
                style="width: 100%"
                placeholder="请选择年级"
                @change="onChangeGrade"
              >
                <a-select-option :value="0">全部年级</a-select-option>
                <a-select-option v-for="item of gradeList" :value="item">{{item}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="studentType != 1">
            <a-col :span="4" v-if="adminLevel !== 'school'">
              <a-form-item>
                <a-select
                  allowClear
                  v-decorator="['containArea']"
                  size="large"
                  style="width: 100%"
                  placeholder="原就读学校"
                  @change="onChangeGrade"
                >
                  <a-select-option :value="0">区内</a-select-option>
                  <a-select-option :value="1">区外</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="4" v-if="adminLevel !== 'school'">
              <a-form-item>
                <a-select
                  allowClear
                  v-decorator="['applyType']"
                  size="large"
                  style="width: 100%"
                  placeholder="办理类型"
                  @change="onChangeGrade"
                >
                  <a-select-option :value="1">材料办理</a-select-option>
                  <a-select-option :value="2">积分办理</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :span="6">
            <a-form-item>
              <a-range-picker
                v-decorator="['time']"
                size="large"
                style="width: 100%"
                :placeholder="['报名开始时间', '报名结束时间'] "
              ></a-range-picker>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="12">
          <a-col :span="3">
            <a-button
              size="large"
              type="primary"
              icon="search"
              style="width: 100%;"
              @click="onClickSearch"
            >搜 索</a-button>
          </a-col>
          <a-col :span="4" v-if="studentType !== 1">
            <a-button
              @click="handleExportExcelData"
              size="large"
              type="primary"
              icon="download"
              style="width: 100%; background: #6eb864; border-color: #6eb864;"
            >导出数据</a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-card>

    <a-card :bordered="false" style="margin-top: -10px;">
      <div class="sub_box clearfix">
        <div
          :span="5"
          v-for="(item, index) of signupNumList"
          :key="index"
          @click="handleClickSubBox(item)"
        >
          <div :class="'sub_item color_'+index">
            {{item.title}}
            <br />
            <span>{{item.num}}人</span>
          </div>
        </div>
      </div>
    </a-card>

    <a-card :bordered="false" title="报名时间统计">
      <index-chart ref="indexChart" :source-data="chartData"></index-chart>
    </a-card>
  </div>
</template>

<script>
import moment from "moment";
import AdminCommon from "./mixins/admin_common";
import IndexChart from "../antv/BarChart";

export default {
  mixins: [AdminCommon],
  components: { IndexChart },
  data() {
    return {
      form: this.$form.createForm(this),
      signupList: [],
      streetList: this.$store.state.streetList,
      schoolList: [],
      signupNumList: [],

      chartData: []
    };
  },
  created() {
    let { systemLevel, adminLevel, user } = this.$store.state;
    console.log(
      "[-> Home] created 用户信息如下::::",
      "[studentType:]",
      this.studentType,
      "[systemLevel:]",
      systemLevel,
      "[adminLevel:]",
      adminLevel,
      "[user:]",
      user
    );

    this.ajaxGetSearchFormData();
  },
  methods: {
    async ajaxGetSearchFormData() {
      const [data1, data2] = await Promise.all([
        this.$ajax.gateway("/bm-kids/ISignupNoticeApi_querySignupNotices", {
          studentType: this.studentType
        }),
        this.$ajax.gateway("/bm-kids/IAreaApi_getMyAreas", {
          studentType: this.studentType
        })
      ]);
      let signupData = data1.data;
      let areaData = data2.data;

      // 处理获取的报名列表数据
      if (signupData.code === 200) {
        signupData = signupData.data;
        if (typeof signupData === "object" && signupData.length > 0) {
          this.signupList = signupData;
          this.form.setFieldsValue({
            signupId: this.signupList[0].signupNoticeId
          });
        }
      }

      if (
        areaData.code === 200 &&
        typeof areaData.data === "object" &&
        areaData.data.length
      ) {
        this.$store.commit("setStreetList", areaData.data);
        this.streetList = areaData.data;
        if (this.adminLevel === "street" && areaData.data.length) {
          this.villageList = areaData.data[0].children || [];
        }
      }
      // 默认选择所有街道和所有幼儿园
      // this.setField('street', 0);
      this.setField("School_OR_Grade", undefined);
      // 加载数据
      this.onClickSearch();
      // 获取通知id后获取幼儿园列表
      this.getKinderSchoolData();
    },
    setField(key, value) {
      // ... 幼儿园版本只有学校，中小学版本只有年级
      if (key === "School_OR_Grade") {
        if (this.studentType === 1) {
          key = "school";
        } else {
          key = "grade";
        }
      }
      let obj = {};
      obj[key] = value;
      this.form.setFieldsValue(obj);
    },

    onChangeStreet(value) {
      // 街道选择发生了变化
      console.log("-> onChangeStreet", value);
      this.schoolList = [];
      // value=0时选择所有街道
      if (!value) {
        this.setField("School_OR_Grade", undefined);
        return;
      }
      try {
        let { streetSchools, children } = this.streetList.find(
          (item, index, arr) => {
            if (Number(item.code) === Number(value)) {
              return item;
            }
          }
        );
        console.log("-> find streetSchools", streetSchools, children);
        if (typeof streetSchools === "object" && streetSchools.length > 0) {
          this.schoolList = streetSchools;
          // this.form.setFieldsValue({ school: streetSchools[0].code });
          this.setField("School_OR_Grade", undefined);
        }

        if (typeof streetSchools === "object" && streetSchools.length > 0) {
          this.schoolList = streetSchools;
          // this.form.setFieldsValue({ school: streetSchools[0].code });
          this.setField("School_OR_Grade", undefined);
        }
      } catch (e) {
        console.error("-> 根据街道Code查询下级SchoolList时错误", value);
      }
    },
    onChangeVillage(value) {},
    onChangeSchool(value) {
      console.log("-> onChangeSchool", value);
    },
    onChangeGrade(value) {
      console.log("-> onChangeSchool", value);
    },

    handleClickSubBox(item) {
      let formVal = this.form.getFieldsValue();
      console.log("-> 带参数跳转到新页面", formVal);

      let path = "/admin/school_detail";
      let query = {};

      if (formVal.time && formVal.time.length) {
        formVal.time = formVal.time.map(v => v.format("YYYY-MM-DD"));
      }

      if (typeof item.status !== "undefined") {
        formVal.status = item.status;
      }

      Object.assign(query, formVal);

      if (this.adminLevel === "admin") {
        path = "/admin/street_detail";
      }

      this.$router.push({
        path,
        query
      });
    },

    async onClickSearch() {
      let formVal = this.form.getFieldsValue();
      console.log("-> onClickSearch formVal", formVal);
      let params = {
        signupNoticeId: formVal.signupId,
        studentType: this.studentType
      };
      if (this.studentType === 1) {
        // 幼儿园
        if (formVal.school) params.schoolId = formVal.school;
      } else if (this.studentType === 2) {
        // 中小学
        if (formVal.grade) params.gradeName = formVal.grade;
      }
      if (formVal.street) {
        params.streetCode = formVal.street;
      }
      if (formVal.time && formVal.time[0] && formVal.time[1]) {
        params.signupBegin = moment(formVal.time[0]).format("YYYY-MM-DD");
        params.signupEnd = moment(formVal.time[1]).format("YYYY-MM-DD");
      }

      if (typeof formVal.applyType !== "undefined") {
        params.applyType = formVal.applyType;
      }

      if (typeof formVal.containArea !== "undefined") {
        params.containArea = formVal.containArea;
      }

      // if (typeof formVal.villageCode !== "undefined") {
      //   params.villageCode = formVal.villageCode;
      // }
      console.log("-> params", params);

      this.signupNumList = [];

      // 首页报名统计 #李茹钰/2019-03-12#
      let {
        data
      } = await this.$ajax.gateway(
        "/bm-kids/IStudentSignupApi_statisticsSignup",
        { body: params }
      );
      console.log("-> 首页报名统计 back", data);
      if (data.code === 200) {
        data = data.data;
        this.signupNumList.push({
          title: "报名总数",
          num: data.allNum
        });
        this.signupNumList.push({
          title: "待审核总数",
          status: 0,
          num: data.waitNum
        });
        this.signupNumList.push({
          title: "审核通过总数",
          status: 2,
          num: data.passNum
        });
        this.signupNumList.push({
          title: "审核待定总数",
          status: 1,
          num: data.undeterminedNum
        });
        this.signupNumList.push({
          title: "审核不通过总数",
          status: 3,
          num: data.notPassNum
        });

        this.chartData = this.formatChartData(data.timeStatisticsSignupVOList);
        this.$nextTick(() => {
          this.$refs.indexChart.initChart();
        });
      }
    },

    async handleExportExcelData() {
      let formVal = this.form.getFieldsValue();
      console.log("-> handleExportExcelData", formVal.signupId);
      const hide = this.$message.loading("处理中..", 0);
      // 导出随迁子女报名统计数据 #李茹钰/2019-04-23#
      let { data } = await this.$ajax.gateway(
        "/bm-kids/IStudentSignupApi_exportDownloadStatistics",
        {
          signupNoticeId: formVal.signupId,
          studentType: this.studentType
        }
      );
      console.log("-> data", data);
      try {
        if (typeof hide !== "undefined") hide();
      } catch (e) {
        console.log("-> catch e", e);
      }
      if (data && data.code === 200 && data.data.ossFileUrl) {
        window.open(data.data.ossFileUrl, "_blank");
      } else {
        this.$message.error(data.message || "导出报名统计数据错误！");
      }
    },

    formatChartData(data) {
      return data.map(({ signupDate, allNum }) => {
        return {
          year: signupDate,
          number: allNum
        };
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.sub_box {
  .sub_item {
    width: 18%;
    min-width: 130px;
    margin-left: 2.5%;
    float: left;
    background: #379ed8;
    border-radius: 8px;
    text-align: center;
    color: #fff;
    padding: 40px 0;
    line-height: 2em;
    font-size: 18px;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    span {
      font-size: 24px;
    }

    &.color_0 {
      margin-left: 0;
      background: #379ed8;
    }

    &.color_1 {
      background: #f76700;
    }

    &.color_2 {
      background: #39cb98;
    }

    &.color_3 {
      background: #f89a00;
    }

    &.color_4 {
      background: #cb0700;
    }
  }
}
</style>
